import type * as hast from 'hast';

import { expandable } from '@gitbook/doc-core';

import type { HastToGastTransformMap } from './types';

/**
 * Parse <summary> and <details> elements.
 */
export const transformBlockExpandable: HastToGastTransformMap = {
    details: async (node: hast.Element, eat, context) => {
        const summary = node.children.find((child: hast.Element) => child.tagName === 'summary');
        if (!summary) {
            return eat('blocks', node.children, context);
        }

        // We should not load nested expandable as we can't handle multiple fragments with the same identifier in a
        // node/document. Ignore instead We also don't allow those tags in the editor, which means these wouldn't
        // render properly if we let them be imported.
        const otherChildren = node.children.filter(
            (child: hast.Element) => child !== summary && child.tagName !== 'details'
        );

        const block = expandable.createExpandableBlock(
            // @ts-expect-error
            await eat('inlines', summary.children, context),
            await eat('blocks', otherChildren, context)
        );

        const isDefaultExpanded =
            typeof node.properties?.open !== 'undefined' &&
            node.properties?.open !== false &&
            node.properties?.open !== 'false';

        return [
            isDefaultExpanded ? block.set('data', block.data.set('defaultExpanded', true)) : block,
        ];
    },
};
